module.exports = __webpack_public_path__ + "static/media/404@3x.8c6c4852.png";